import {
  AutocompleteInput,
  BooleanInput,
  ReferenceInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const filterToQuery = (searchText) => ({ all: searchText });

const accountReceivablePcmAgeFilterList = [
  <MuiDatePickerInput
    alwaysOn
    source="start_date"
    variant="outlined"
    label="mine.label.start_date"
    maxDateSource="end_date"
  />,
  <MuiDatePickerInput
    alwaysOn
    source="end_date"
    variant="outlined"
    label="mine.label.end_date"
    minDateSource="start_date"
  />,
  <MuiDatePickerInput
    alwaysOn
    source="cut_off"
    variant="outlined"
    // label=""
  />,
  <ReferenceInput
    alwaysOn
    source="start_created_at"
    reference="customers"
    sort={{ field: "customers.created_at", order: "ASC" }}
    perPage={10}
  >
    <AutocompleteInput
      resettable
      optionValue="created_at"
      optionText="code"
      variant="outlined"
      label="mine.label.start_code"
    />
  </ReferenceInput>,
  <ReferenceInput
    alwaysOn
    source="end_created_at"
    reference="customers"
    sort={{ field: "customers.created_at", order: "ASC" }}
    perPage={10}
  >
    <AutocompleteInput
      resettable
      optionValue="created_at"
      optionText="code"
      variant="outlined"
      label="mine.label.end_code"
      // filterToQuery={(search) => ({ created_at: search })}
    />
  </ReferenceInput>,
  <ReferenceInput
    alwaysOn
    resettable
    source="name"
    reference="customers"
    sort={{ field: "customers.name", order: "ASC" }}
    perPage={25}
  >
    <AutocompleteInput
      resettable
      optionValue="name"
      optionText="name"
      filterToQuery={filterToQuery}
      variant="outlined"
      label="mine.label.name"
    />
  </ReferenceInput>,
  <BooleanInput alwaysOn source="is_cashed" label="Cair" />,
];

export default accountReceivablePcmAgeFilterList;
